import Head from 'next/head';
import * as React from 'react';

const styles = `
  * {
    box-sizing:border-box
  }

  html,body {
    background:white;
    color:#444;
    margin:0;
    padding:0;
    height:100%;
  }

  html,input {
    font-family:Helvetica Neue,Helvetica,Arial,sans-serif;
    font-weight:300;
    line-height:1.4;
  }

  a {
    color:#555;
    text-decoration:none;
    transition:color .3s;
    position:relative;
  }

  a:after {
    border-bottom:1px solid rgba(0,0,0,.2);
    content:'';
    transition:border-color .4s;
    position:absolute;
    bottom:0;
    left:0;
    width:100%;
  }

  a:hover {
    color:#222
  }

  a:hover:after {
    border-color:rgba(0,0,0,.4);
  }

  h1 {
    font-size:22.4px;
    font-size:1.4rem;
    font-weight:400;
    margin:12.8px 0;
    margin:.8rem 0
  }

  h1 a:after {
    display:none;
  }

  h2 {
    border-top:1px solid #e62b1e;
    font-size:19.2px;
    font-size:1.2rem;
    font-weight:400;
    margin:22.4px 0 9.6px;
    margin:1.4rem 0 .6rem;
    padding-top:22.4px;
    padding-top:1.4rem
  }

  p {
    margin:9.6px 0;
    margin:.6rem 0
  }

  ul {
    font-size:14.4px;
    font-size:.9rem;
    list-style-type:circle;
    margin:0;
    padding:0;
  }

  li {
    color:rgba(0,0,0,.2);
    margin:4.8px 0;
    margin:.3rem 0;
  }

  .t {
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }

  .t__c {
    display:table-cell;
    vertical-align:middle;
  }

  .Error {
    background:#fafafa;
    font-size:90%;
    padding:12.8px;
    padding:.8rem;
    position:relative;
    margin:12.8px -12.8px;
    margin:.8rem -.8rem;
  }

  .Error,.Error a {
    color:#777;
    text-decoration:none;
  }

  .Error a:after {
    display:none;
  }

  .Notice {
    margin:0 auto;
    padding:0 32px 16px;
    padding:0 2rem 1rem;
    width:100%;
    max-width:544px;
    max-width:34rem
  }

  .Search {
    margin:12.8px 0;
    margin:.8rem 0;
    position:relative;
    width:100%;
    max-width:320px;
    max-width:20rem;
  }

  .Search__input {
    background:#FFF;
    border:1px solid #d4d4d4;
    border-radius:4px;
    font-size:16px;
    font-size:1rem;
    padding:7px 29px 7px 8px;
    width:100%
  }

  .Search__button {
    background-color:transparent;
    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAMFBMVEVMaXFmZmZmZmZfX19mZmZmZmZlZWVlZWVlZWVmZmZmZmZnZ2dlZWVlZWVmZmZmZmYuzR/OAAAAD3RSTlMAqUYEMXSb01+JHBDq+b3CbPMEAAABN0lEQVR42u2U3XKFIAyEQ0gEBfX937akzCl1qCunzrQ37p2Ez/xslB49+gelOIW9KDuVN1Fx+zeFSONaXmjDh7NzBVY3q6rL9Wn2Q6zuJsdfdcz1YITWvsw02dl2TXOrsTu9nNVabil1EqOZsFzL0OfOCftr/frTWehl4hNLfS7uoZkls+QsGHHXOO5LcAKw+elRTxnAoawCXh8w7xVuAp9P04TdEDCR2/CdsoPZDI1cCJqBjUTfMiwsQyNpsaZRy5GAAtiDrcbwQCcYukrNp7+YBcOy/zyzZG/dhn6e3OU1tpUNvC5Sf+zXah6h/SedY8PZ5jxKz/Weiywicc4NHamc7f5RYZxOuh7TLd6N0+Sje/Gb2l71NFYSZql7caQjDaunA92gV7pBb3SDFvqdNO+b0KNHf6UP9pkYxiqw5x4AAAAASUVORK5CYII=);
    background-repeat:no-repeat;
    background-size:30px 30px;
    border:none;
    overflow:hidden;
    text-indent:-9999em;
    margin-top:-15px;
    padding:0;
    position:absolute;
    top:50%;
    right:2px;
    width:30px;
    height:30px;
  }
`;

export default function Custom404() {
  const id = React.useId();

  return (
    <>
      <Head>
        <title>TED | 404: Not Found</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style dangerouslySetInnerHTML={{ __html: styles }} />
      </Head>
      <div className="t">
        <div id={`custom404-${id}`} className="t__c">
          <div className="Notice">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0, 0, 410, 164">
              <path
                d="M43 54H2V16h127v38H88v109H43zM311.976 125l18.584.126c28.145 0 32.259-22.814 32.259-36.595 0-9.233-3.187-34.531-35.851-34.531h-14.992v71zM267 16h74.858C390.731 16 408 52.172 408 89.15c0 45.022-23.819 73.85-74.968 73.85H267V16z"
                fill="#E62B1E"
              />
              <path
                d="M136 16h124v38h-78v18h78v35h-78v18h78v38H136z"
                stroke="#CCC"
                strokeWidth="1"
                strokeDasharray="4,6"
                fill="none"
              />
            </svg>
            <h1>Sorry, we can't find that.</h1>
            <p>Perhaps we can help you find the content you're looking for:</p>
            <form
              className="Search"
              action="https://www.ted.com/search"
              role="search"
            >
              <input
                className="Search__input"
                placeholder="Search TED.com…"
                name="q"
              />
              <input className="Search__button" type="submit" value="Go" />
            </form>
            <div className="Error">
              <a href="https://en.wikipedia.org/wiki/List_of_HTTP_status_codes#404">
                HTTP Error 404
              </a>
            </div>
            <h2>What&apos;s next?</h2>
            <ul>
              {typeof window !== 'undefined' &&
                window.history &&
                window.history.length > 1 &&
                document.referrer &&
                document.referrer.match(/^https?:\/\//) && (
                  <li>
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault();
                        window.history.back();
                      }}
                      role="button"
                    >
                      Go to the previous page
                    </a>
                  </li>
                )}
              <li>
                <a href="https://www.ted.com">Go to the TED.com homepage</a>
              </li>
              <li>
                <a href="https://support.ted.com">Visit our Help Desk</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
